// extracted by mini-css-extract-plugin
export var container = "recipe-process-module--container--3171d";
export var ingredientsLeft = "recipe-process-module--ingredients-left--cfbd1";
export var method = "recipe-process-module--method--9f77c";
export var processColumns = "recipe-process-module--process-columns--2626b";
export var subTitle = "recipe-process-module--sub-title--67d8f";
export var subsubTitle = "recipe-process-module--subsub-title--0abc0";
export var triangle_wrapper_left = "recipe-process-module--triangle_wrapper_left--3c9b0";
export var triangle_wrapper_right = "recipe-process-module--triangle_wrapper_right--88c58";